import axiosGraphQL from './GraphQL/axiosGraphQL';
import { CalculationSetupQueries } from './GraphQL/Queries/CalculationSetupQueries';
import {
  CalculationSetupVariables,
  ICreateRewardSetup,
  IGetComboboxGroupRoleManagement,
  IGetComboboxRewardSetup,
  IGetListRewardCondition,
  IGetListRewardFrame,
  IUpdateRewardSeqment,
  IUpdateRewardSeqmentById,
  IUpdateRewardSetup,
} from './GraphQL/Variables/CalculationSetupVariables';

export const CalculationSetupApis = {
  // RewardCondition
  getListRewardCondition: async (
    params: IGetListRewardCondition,
  ): Promise<any> => {
    return axiosGraphQL.post('/graphql', {
      query: CalculationSetupQueries.QUERY_GET_LIST_REWARD_CONDITION,
      variables: CalculationSetupVariables.getListRewardCondition(params),
    });
  },

  saveRewardCondition: async (params: any): Promise<any> => {
    return axiosGraphQL.post('/graphql', {
      query: CalculationSetupQueries.QUERY_CREATE_REWARD_CONDITION,
      variables: CalculationSetupVariables.saveRewardCondition(params),
    });
  },

  // RewardFrame
  getListRewardFrame: async (params: IGetListRewardFrame): Promise<any> => {
    return axiosGraphQL.post('/graphql', {
      query: CalculationSetupQueries.QUERY_GET_LIST_REWARD_FRAME,
      variables: CalculationSetupVariables.getListRewardFrame(params),
    });
  },

  saveRewardFrame: async (params: any): Promise<any> => {
    return axiosGraphQL.post('/graphql', {
      query: CalculationSetupQueries.QUERY_CREATE_REWARD_FRAME,
      variables: CalculationSetupVariables.saveRewardFrame(params),
    });
  },

  getComboboxRewardSetup: async (
    params: IGetComboboxRewardSetup,
  ): Promise<any> => {
    return axiosGraphQL.post('/graphql', {
      query: CalculationSetupQueries.GET_COMBOBOX_REWARD_SETUP,
      variables: CalculationSetupVariables.getComboboxRewardSetup(params),
    });
  },

  getComboboxGroupRoleManagement: async (
    params: IGetComboboxGroupRoleManagement,
  ): Promise<any> => {
    return axiosGraphQL.post('/graphql', {
      query: CalculationSetupQueries.GET_COMBOBOX_GROUP_ROLE_MANAGEMENT,
      variables:
        CalculationSetupVariables.getComboboxGroupRoleManagement(params),
    });
  },

  createRewardSetup: async (params: ICreateRewardSetup): Promise<any> => {
    return axiosGraphQL.post('/graphql', {
      query: CalculationSetupQueries.QUERY_CREATE_REWARD_SETUP,
      variables: CalculationSetupVariables.createRewardSetup(params),
    });
  },

  updateRewardSetup: async (params: IUpdateRewardSetup): Promise<any> => {
    return axiosGraphQL.post('/graphql', {
      query: CalculationSetupQueries.QUERY_UPDATE_REWARD_SETUP,
      variables: CalculationSetupVariables.updateRewardSetup(params),
    });
  },

  updateRewardSeqmentStatus: async (
    params: IUpdateRewardSeqment,
  ): Promise<any> => {
    return axiosGraphQL.post('/graphql', {
      query: CalculationSetupQueries.UPDATE_REWARD_SEQMENT_STATUS,
      variables: CalculationSetupVariables.updateRewardSeqmentStatus(params),
    });
  },

  updateRewardSeqmentById: async (
    params: IUpdateRewardSeqmentById,
  ): Promise<any> => {
    return axiosGraphQL.post('/graphql', {
      query: CalculationSetupQueries.UPDATE_REWARD_SEQMENT_BY_ID,
      variables: CalculationSetupVariables.updateRewardSeqmentById(params),
    });
  },
};
